export const sortAlphabeticallyByProperty = <T>(arr: T[], prop: keyof T) => {
    return [...arr].sort((a, b) => {
    // Ensure we are dealing with strings for localeCompare
    // Using String() handles numbers, nulls, or undefined safely
        const valA = String(a[prop] ?? '');
        const valB = String(b[prop] ?? '');
        return valA.localeCompare(valB);
    });
};
